
export const GET_USER_DETAILS = "get_user_details";
export const SAVE_USER_DETAILS = "save_user_details";
export const CLEAR_USER_DETAILS = "clear_user_details";
export const SAVE_USER_ROLES = "save_user_roles";

export const ANALYST = "ANALYST";
export const ADMIN = "ADMIN";
export const GENERAL_MANAGER = "GENERAL_MANAGER";
export const CONFIGURATOR = "CONFIGURATOR";
export const CASHIER = "CASHIER";
export const CASHIER_MODERATOR = "CASHIER_MODERATOR";
export const ANALYST_MODERATOR = "ANALYST_MODERATOR";
export const CLIENT = "CLIENT";
export const CUSTOMER_CARE = "CUSTOMER_CARE";
export const OPERATIONS_OFFICER = "OPERATIONS_OFFICER";
export const LOAN_PORTFOLIO_MANAGER = "LOAN_PORTFOLIO_MANAGER";
export const COLLECTIONS_OFFICER = "COLLECTIONS_OFFICER";
export const COLLECTIONS_MODERATOR = "COLLECTIONS_MODERATOR";
export const DEFAULT_USER_SELECTION = "select User";
